// extracted by mini-css-extract-plugin
module.exports = {"VideoContainer":"Brief_VideoContainer__sxXKf","TitleList":"Brief_TitleList__kdDyF"};